import { useGetRequiredRule } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { MetaTagsFormFieldsNames } from '../helpers/types';

export const useMetaTagsFormRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });

  return {
    [MetaTagsFormFieldsNames.SLUG]: [requiredRule],
    [MetaTagsFormFieldsNames.INDEX]: [requiredRule],
  };
};
